import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    TextField,
    Typography,
} from '@material-ui/core';
import { UPDATE_AWARDING_RULE } from '../../../store/awardingRule';
import './InformationSection.scss';
import '../../../SetupList/SetupEdit/SetupEdit.scss';

const InputTitle = (props) => (
    <Typography
        component="p"
        className="input-label"
        {...props}
    >
        {props.children}
    </Typography>
);

const InputDisclaimer = (props) => (
    <p {...props}>
        <small className="input-disclaimer">
            {props.children}
        </small>
    </p>
);

/**
 * @param {{validationErrors: {[Key: string] : boolean}}} props
 */
function InformationSection(props) {
    const { validationErrors } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.awardingRules.informationSection' });
    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminAwardingRule } = useSelector((state) => state);
    const {
        name,
        description,
    } = adminAwardingRule;

    /**
     * @param {string} target
     * @param {string} value
     */
    const updateAwardingRuleStore = (target, value) => {
        dispatch({
            type: UPDATE_AWARDING_RULE,
            payload: {
                [target]: value,
            },
        });
    };

    return (
        <Card className="card">
            <CardHeader
                className="card--header"
                color="textSecondary"
                avatar={<Avatar className="avatar">{1}</Avatar>}
                title={t('title')}
            />
            <CardContent>
                <div>
                    <InputTitle>{t('nameLabel')}</InputTitle>
                    <TextField
                        // @ts-ignore
                        error={validationErrors.name}
                        value={name}
                        onChange={(event) => updateAwardingRuleStore('name', event.target.value)}
                        inputProps={{ maxLength: 50 }}
                        placeholder={t('namePlaceholder')}
                        variant="outlined"
                    />
                    {
                        validationErrors.name ? <span style={{ color: 'red' }}>{t('nameError')}</span> : null
                    }
                    <InputDisclaimer>{t('nameDisclaimer')}</InputDisclaimer>
                </div>
                <div>
                    <InputTitle>{t('descriptionLabel')}</InputTitle>
                    <TextField
                        // @ts-ignore
                        value={description}
                        onChange={(event) => updateAwardingRuleStore('description', event.target.value)}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 250 }}
                        placeholder={t('descriptionPlaceholder')}
                        variant="outlined"
                    />
                    <InputDisclaimer>{t('descriptionDisclaimer')}</InputDisclaimer>
                </div>
            </CardContent>
        </Card>

    );
}

export default InformationSection;
